module.exports = __webpack_public_path__ + "img/google.2be69cfe.svg";